import { useEffect, useState, useVisibilityController } from '@frontend/react';
import { handleMutation } from '@frontend/web/utils';
import { useEditProfileMutation, useRetrieveClientStatusQuery } from './api';

export const useReactivationFlow = () => {
  const [hasReactivationError, setHasReactivationError] = useState(false);
  const [isReactivationModalOpen, { close: closeReactivationModal, open: openReactivationModal }] =
    useVisibilityController();

  const { data: clientStatus } = useRetrieveClientStatusQuery();
  const [updateClient, { isLoading: isReactivating, isSuccess }] = useEditProfileMutation();

  const isChurned = clientStatus?.membershipStatus === 'canceled';

  // Open modal when user is churned (but not if mutation just succeeded)
  useEffect(() => {
    if (isChurned && !isReactivationModalOpen && !isSuccess) {
      openReactivationModal();
    }
  }, [isChurned, isReactivationModalOpen, isSuccess, openReactivationModal]);

  // Reset error state when modal opens
  useEffect(() => {
    if (isReactivationModalOpen) {
      setHasReactivationError(false);
    }
  }, [isReactivationModalOpen]);

  const handleReactivation = () => {
    if (isReactivating) return; // Prevent double-clicks

    handleMutation({
      mutation: () => updateClient({ membershipStatus: 'active' }).unwrap(),
      onError: () => {
        // Show error state in modal so user can retry
        setHasReactivationError(true);
      },
      onSuccess: () => {
        // Clear error state on success
        setHasReactivationError(false);
        // No manual refetch needed - RTK Query handles via tag invalidation
        closeReactivationModal();
      },
      showErrorToast: false,
      showSuccessToast: false,
    });
  };

  return {
    closeReactivationModal,
    handleReactivation,
    hasReactivationError,
    isChurned,
    isReactivating,
    isReactivationModalOpen,
  };
};
